import { useRef, useEffect, useState, FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import useTranslate from '../../../i18n/useTranslate'
import Divider from '@material-ui/core/Divider'
import { Form as FinalForm, FormRenderProps } from 'react-final-form'

import Button from '../../../control/button/button'
import Dialog from '../../../control/dialog/dialog'
import FormDialogChangePassword from '../change-password/Form'
import FormDialogChangePasscode from '../change-passcode/Form'

import usePreferanceProfile, { FormProps } from '../../../services/um/usePreferenceProfile'

import useAuthenStore from '../../../stores/authen/authenStore'
import constUserGroup from '../../../constants/userGroup'
import UploadProfile from './UploadProfile'
import Information from './Information'
import Line from './Line'
import UploadLogo from './UploadLogo'
import NotificationSetting from './NotificationSetting'

interface FormPrfProps {
    onSaveInformation: (values: FormProps) => void
    getNewProfile: () => void
}
const Form: FC<FormPrfProps> = ({ onSaveInformation, getNewProfile }) => {
    const classes = useStyles()
    const t = useTranslate()
    const preferanceProfileHook = usePreferanceProfile()

    const authenStore = useAuthenStore()
    // const authenAction = useAuthenAction()

    const dialogChnagePasswordRef = useRef<Record<string, Function>>()
    const dialogChnagePasscodeRef = useRef<Record<string, Function>>()
    // const [configDialog, setConfigDialog] =
    //     useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    // const dialogTwoRef = useRef<Record<string, Function>>()
    const formPropsRef = useRef<FormRenderProps>()

    const [initialForm, setInitialForm] = useState<FormProps>()

    useEffect(() => {
        getInitialForm()
    }, [authenStore.profile.userId])

    const getInitialForm = async () => {
        const data = await preferanceProfileHook.getPreferanceProfile(authenStore.profile.userId)

        setInitialForm(data)
    }

    const validateForm = (values: FormProps) => {
        const errors: any = {}
        if (!values.username) {
            errors.username = t.get('LABEL.REQUIRE_FIELD')
        }
        // if (!values.email) {
        //     errors.email = t.get('LABEL.REQUIRE_FIELD')
        // }
        if (!values.nameTH) {
            errors.nameTH = t.get('LABEL.REQUIRE_FIELD')
        }
        if (!values.nameEN) {
            errors.nameEN = t.get('LABEL.REQUIRE_FIELD')
        }
        // if (!values.telephone) {
        //     errors.telephone = t.get('LABEL.REQUIRE_FIELD')
        // }
        return errors
    }

    const onRefDialogChnagePassword = (func: Record<string, Function>) => {
        dialogChnagePasswordRef.current = func
    }

    const onRefDialogChangePasscode = (func: Record<string, Function>) => {
        dialogChnagePasscodeRef.current = func
    }

    const handleOpenDialogChangePassword = () => {
        dialogChnagePasswordRef.current?.openDialog()
    }

    const handleOpenDialogChangePasscode = () => {
        dialogChnagePasscodeRef.current?.openDialog()
    }

    const handleClickConfirm = () => {
        formPropsRef.current?.handleSubmit()
        getInitialForm()
    }

    const onRefFormProps = (func: FormRenderProps) => {
        formPropsRef.current = func
    }

    const onRefCloseDialog = () => {
        dialogChnagePasswordRef.current?.closeDialog()
        dialogChnagePasscodeRef.current?.closeDialog()
        getInitialForm()
    }

    const isShowChangPassword =
        authenStore.profile.userGroupId !== constUserGroup.researcher &&
        authenStore.profile.userGroupId !== constUserGroup.committee

    return (
        <>
            <FinalForm initialValues={initialForm} onSubmit={onSaveInformation} validate={validateForm}>
                {({ handleSubmit, form, values }) => {
                    return (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid container spacing={1} className={classes.padding}>
                                    <Grid item xs={12}>
                                        <Typography variant={'h4'}>
                                            {t.get('UM.PROFILE.PERSONAL_INFORMATION')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Typography variant="h6">{t.get('UM.PROFILE.IMG_PROFILE')}</Typography>
                                        <Typography variant="caption">
                                            {t.get('UM.PROFILE.CHANGE_IMG_ONSITE')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={8} className={classes.elementUpload}>
                                        <img
                                            src={
                                                authenStore.profile.image_path
                                                    ? `${process.env.REACT_APP_UPLOAD}${authenStore.profile.image_path}`
                                                    : `${process.env.PUBLIC_URL}/img/default.jpg`
                                            }
                                            // src={`${process.env.REACT_APP_UPLOAD}${authenStore.profile.image_path}`}
                                            id="profile"
                                            alt=""
                                            width="100"
                                            height="100"
                                            className={classes.image}
                                            onError={(e: any) => {
                                                e.target.src = `${process.env.PUBLIC_URL}/img/default.jpg`
                                            }}
                                        />
                                        <div className={classes.uploadFile}>
                                            <div>
                                                <UploadProfile getNewProfile={getNewProfile} />
                                            </div>
                                            <Typography variant="caption">
                                                {t.get('UM.PROFILE.MAXIMUM_FILE_UPLOAD')}
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Divider />

                                <Grid container spacing={1} className={classes.padding}>
                                    <NotificationSetting />
                                </Grid>
                                <Divider />

                                <Grid container spacing={1} className={classes.padding}>
                                    <Information
                                        position={values.position}
                                        title={values.title}
                                        handleSubmit={handleSubmit}
                                    />
                                </Grid>
                                <Divider />
                                <Grid container spacing={1} className={classes.padding} alignItems="center">
                                    {initialForm && !initialForm.cu_net && (
                                        <Grid item xs={12} md={4}>
                                            <Typography variant="h6">{t.get('UM.PROFILE.PASSWORD')}</Typography>
                                            <Typography variant="caption">
                                                {t.get('UM.PROFILE.CHANGE_PASSWORD_REDIRECT_TO_LOGIN_PAGE')}
                                            </Typography>
                                        </Grid>
                                    )}
                                    {initialForm && !initialForm.cu_net && (
                                        <Grid item xs={12} md={8}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} md={6}>
                                                    <Button
                                                        size={'medium'}
                                                        fullWidth
                                                        variant="contained"
                                                        color="default"
                                                        onClick={handleOpenDialogChangePassword}
                                                    >
                                                        {t.get('UM.PROFILE.CHANGE_PASSWORD')}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}

                                    {isShowChangPassword && (
                                        <>
                                            <Grid item xs={12} md={4}>
                                                <Typography variant="h6">{t.get('UM.PROFILE.PASSCODE')}</Typography>
                                                <Typography variant="caption">
                                                    {t.get('UM.PROFILE.PASSCODE_FOR_SIGN_NAME')}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} md={6}>
                                                        <Button
                                                            size={'medium'}
                                                            fullWidth
                                                            variant="contained"
                                                            color="default"
                                                            onClick={handleOpenDialogChangePasscode}
                                                        >
                                                            {t.get('UM.PROFILE.CHANGE_PASSCODE')}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}
                                </Grid>

                                {initialForm &&
                                    initialForm.usergroupID.filter((item) => {
                                        return item !== 1
                                    }).length > 0 && (
                                        <>
                                            <Divider />
                                            <Grid container spacing={1} className={classes.padding} alignItems="center">
                                                <Line />
                                            </Grid>
                                        </>
                                    )}

                                {initialForm &&
                                    initialForm.usergroupID.filter((item) => {
                                        if (item === 3 || item === 6 || item === 7) {
                                            return item
                                        }
                                    }).length > 0 && (
                                        <>
                                            <Divider />
                                            <Grid container spacing={1} className={classes.padding} alignItems="center">
                                                <Grid item xs={12}>
                                                    <Typography variant="h6">{`${t.get(
                                                        'UM.UPLOAD.HEADER2',
                                                    )}`}</Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <UploadLogo initialValue={initialForm} form={form} />
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>

            <Dialog
                onRef={onRefDialogChnagePassword}
                type="dialog-element"
                title={t.get('UM.PROFILE.CHANGE_PASSWORD')}
                content={
                    <FormDialogChangePassword onRefFormProps={onRefFormProps} onRefCloseDialog={onRefCloseDialog} />
                }
                onClickConfirm={handleClickConfirm}
            />

            <Dialog
                onRef={onRefDialogChangePasscode}
                type="dialog-element"
                title={t.get('UM.PROFILE.CHANGE_PASSCODE')}
                content={
                    <FormDialogChangePasscode
                        onRefFormProps={onRefFormProps}
                        onRefCloseDialog={onRefCloseDialog}
                        isPasscode={initialForm?.isPasscode ?? false}
                    />
                }
                onClickConfirm={handleClickConfirm}
            />
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    padding: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    elementUpload: {
        display: 'flex',
        gap: '30px',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'center',
        },
    },
    uploadFile: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        [theme.breakpoints.down('md')]: {
            alignItems: 'center',
        },
    },
    image: {
        borderRadius: '50%',
    },
}))

export default Form
